import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { Oracle, Queue } from '@switchboard-xyz/on-demand';

export default class OracleCreate extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Create an oracle account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    queue: Flags.string({
      description: 'public key of the queue account',
      required: true,
    }),
  };

  static args = {};

  async run() {
    const { flags } = await this.parse(this.constructor as typeof OracleCreate);

    const program = await this.program;

    // Create the oracle init instructions.
    const queue = new web3.PublicKey(flags.queue);
    const [oracle, ixs, oracleKp] = await Oracle.create(program, { queue });
    const queueAccount = new Queue(oracle.program, queue);
    const queueLut = await queueAccount.loadLookupTable();

    // Sign and send the transaction
    await this.signAndSend(ixs, [queueLut], [oracleKp]);

    // Print the oracle and queue keys to the console
    console.log();
    console.log(`PULL_ORACLE=${oracle.pubkey.toBase58()}`);
    console.log(`PULL_QUEUE=${queue.toBase58()}`);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, '# ORACLE - failed to create oracle account');
  }
}
